import { EntityTemplateVariables } from '@tools/interfaces/template';
import { getContactFieldsForEntity } from './template-contact';
import { getDisciplineFieldsForEntity } from './template-discipline';
import { getResourceFieldsForEntity } from './template-resource';
import { getAccessControlBadgeFieldsForEntity } from './template-access-control-badge';
export const templateBookingEvent: EntityTemplateVariables = {
  fields: [
    {
      label: 'templates.booking_events.status.label',
      contentValue: `{{ booking_event.status }}`,
      description: 'templates.booking_events.status.description',
    },
    {
      label: 'templates.booking_events.date.label',
      contentValue: `{{ booking_event.date | date("d/m/Y") }}`,
      description: 'templates.booking_events.date.description',
    },
    {
      label: 'templates.booking_events.start_time.label',
      contentValue: `{{ booking_event.start_time | date("H:i") }}`,
      description: 'templates.booking_events.start_time.description',
    },
    {
      label: 'templates.booking_events.end_time.label',
      contentValue: `{{ booking_event.end_time | date("H:i")}}`,
      description: 'templates.booking_events.end_time.description',
    },
    {
      label: 'templates.booking_events.code.label',
      contentValue: `{{ booking_event.code }}`,
      description: 'templates.booking_events.code.description',
    },
    {
      label: 'templates.booking_events.name.label',
      contentValue: `{{ booking_event.name }}`,
      description: 'templates.booking_events.name.description',
    },
    {
      label: 'templates.booking_events.comment.label',
      contentValue: `{{ booking_event.comment }}`,
      description: 'templates.booking_events.comment.description',
    },
    {
      label: 'templates.booking_events.cancel_reason.label',
      contentValue: `{{ templateHelper.cancel_reason(booking_event.cancel_reason) }}`,
      description: 'templates.booking_events.cancel_reason.description',
    },
    {
      label: 'templates.booking_events.cancel_reason_description.label',
      contentValue: `{{ booking_event.cancel_reason_description }}`,
      description: 'templates.booking_events.cancel_reason_description.description',
    },
    //This is not ideal but we need to have access to the acess control badge fields in the booking event loop
    {
      label: 'templates.access_control_badge.badge_number.label',
      contentValue: `{{ booking_event.accessControlBadge.badge_number }}`,
      description: 'templates.access_control_badge.badge_number.description',
    },
    {
      label: 'templates.access_control_badge.code.label',
      contentValue: `{{ booking_event.accessControlBadge.code }}`,
      description: 'templates.access_control_badge.code.description',
    },
    {
      label: 'templates.access_control_badge.status.label',
      contentValue: `{{ booking_event.accessControlBadge.status }}`,
      description: 'templates.access_control_badge.status.description',
    },
    {
      label: 'templates.access_control_badge.type.label',
      contentValue: `{{ booking_event.accessControlBadge.type }}`,
      description: 'templates.access_control_badge.type.description',
    },
  ],
  related: [
    {
      relationName: 'contact',
      relationType: 'simple',
      label: 'templates.bookings.contact.label',
      description: 'templates.bookings.contact.description',
      fields: getContactFieldsForEntity('booking_event.'),
    },
    {
      relationName: 'booking',
      relationType: 'simple',
      label: 'templates.booking_events.booking.label',
      description: 'templates.booking_events.booking.description',
      fields: [
        {
          label: 'templates.bookings.code.label',
          contentValue: '{{ booking_event.booking.code }}',
          description: 'templates.bookings.code.description',
        },
        {
          label: 'templates.bookings.name.label',
          contentValue: '{{ booking_event.booking.name }}',
          description: 'templates.bookings.name.description',
        },
        {
          label: 'templates.bookings.comment.label',
          contentValue: '{{ booking_event.booking.comment }}',
          description: 'templates.bookings.comment.description',
        },
        {
          label: 'templates.bookings.booking_price.label',
          contentValue: '{{ booking_event.booking.booking_price }}',
          description: 'templates.bookings.booking_price.description',
        },
      ],
    },
    {
      relationName: 'resource',
      relationType: 'simple',
      label: 'templates.bookings.resources.label',
      description: 'templates.bookings.resource.description',
      fields: getResourceFieldsForEntity('booking_event.'),
    },
    {
      relationName: 'discipline',
      relationType: 'simple',
      label: 'templates.bookings.discipline.label',
      description: 'templates.bookings.discipline.description',
      fields: getDisciplineFieldsForEntity('booking_event.'),
    },
    {
      relationName: 'accessControlBadge',
      relationType: 'simple',
      label: 'templates.booking_events.access_control_badge.label',
      description: 'templates.booking_events.access_control_badge.description',
      fields: getAccessControlBadgeFieldsForEntity('booking_event.'),
    },
  ],
  relatedInLoop: [],
};
